import { GeoGirafeApp } from '@geogirafe/lib-geoportal/core';

import ApplicationsComponent from '../../components/applications/component';
import ReportPanelComponent from '../../components/report-panel/component';
import SimpleReportComponent from '../../components/report-panel/simple-report/component';
import ErdbebenMikrozonierungComponent from '../../components/report-panel/erdbebenmikrozonierung/component';
import LiegenschaftskenndatenComponent from '../../components/report-panel/liegenschaftskenndaten/component';
import LiegtypselectComponent from '../../components/report-panel/liegtypselect/component';
import KleinbautenAusschnittComponent from '../../components/report-panel/kleinbautenausschnitt/component';
import MapBSLayoutComponent from '../../components/layout/component';
import ImprintComponent from '../../components/imprint/imprint-panel/component';
import ImprintContent from '../../components/imprint/imprint-content/component';
import MapbsContext from './mapbscontext';
import MapbsInfoboxComponent from '../../components/bsinfobox/component';
import MapbsSearchComponent from '../../components/search/component';
import MapbsThemeComponent from '../../components/themes/components';
import MapbsPrototypeBannerComponent from '../../components/prototypebanner/component';

export default class MapbsGeoGirafeApp extends GeoGirafeApp {
  private checkSso() {
    const urlParams = new URLSearchParams(window.location.search);
    const sso = urlParams.get('sso');
    if (sso !== null) {
      this.injectConfigMetaTags();
    }
  }

  private injectConfigMetaTags() {
    const location = new URL(import.meta.url);
    // The following 2 lines is a small hack to make the injection work in both context
    // (debugging in vite + production app)
    location.pathname = location.pathname.replace('/src/bs/base', '');
    location.pathname = location.pathname.replace('/assets', '');

    const origin = `${location.origin}${location.pathname.substring(0, location.pathname.lastIndexOf('/'))}`;

    const metaTag = document.querySelector('meta[name="configs"]') as HTMLMetaElement;
    metaTag.content += ',sso';

    const linkSso = document.createElement('link');
    linkSso.rel = 'config-sso-url';
    linkSso.href = `${origin}/config.sso.json`;
    document.head.appendChild(linkSso);
  }

  protected override async initialize() {
    this.checkSso();
    super.initialize();
  }

  protected override initializeInterface() {
    super.initializeInterface();
    /**
     * This method allows you to execute some code to initialize the custom application.
     * For example, you can put here custom code to initialize custom singletons, workers,
     * or to initialize librairies.
     */
    this.context.extendedContext = new MapbsContext(this.context);
  }

  protected override defineCoreComponents() {
    super.defineCoreComponents();
    // Define custom components
    customElements.define('mapbs-applications-component', ApplicationsComponent);
    customElements.define('mapbs-report-panel-component', ReportPanelComponent);
    customElements.define('simple-report-component', SimpleReportComponent);
    customElements.define('erdbeben-mikrozonierung-component', ErdbebenMikrozonierungComponent);
    customElements.define('mapbs-infobox', MapbsInfoboxComponent);
    customElements.define('liegenschafts-kenndaten-component', LiegenschaftskenndatenComponent);
    customElements.define('liegtypselect-component', LiegtypselectComponent);
    customElements.define('kleinbauten-ausschnitt-component', KleinbautenAusschnittComponent);
    customElements.define('mapbs-imprint-component', ImprintComponent);
    customElements.define('mapbs-layout', MapBSLayoutComponent);
    customElements.define('mapbs-imprint-content', ImprintContent);
    customElements.define('mapbs-search', MapbsSearchComponent);
    customElements.define('mapbs-theme-select', MapbsThemeComponent);
    customElements.define('mapbs-prototype-banner', MapbsPrototypeBannerComponent);
  }
}
